import { Ionicons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

interface DailyIntroModalProps {
  visible: boolean;
  onClose: () => void;
}

export default function DailyIntroModal({ visible, onClose }: DailyIntroModalProps) {
  const { t } = useTranslation();
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.card}>
          <TouchableOpacity
            style={styles.closeButton}
            onPress={onClose}
            accessibilityRole="button"
            accessibilityLabel={t("common.close")}
          >
            <Ionicons name="close" size={22} color="#333" />
          </TouchableOpacity>

          <Text style={styles.title}>{t("home.intro.title")}</Text>

          <ScrollView showsVerticalScrollIndicator={false}>
            <Text style={styles.paragraph}>{t("home.intro.p1")}</Text>
            <Text style={styles.paragraph}>{t("home.intro.p2")}</Text>
            <Text style={styles.paragraph}>{t("home.intro.p3")}</Text>
            <Text style={styles.paragraph}>{t("home.intro.p4")}</Text>
          </ScrollView>

          <TouchableOpacity
            style={styles.ctaWrapper}
            onPress={onClose}
            activeOpacity={0.85}
            accessibilityRole="button"
          >
            <LinearGradient
              colors={["#1C453F", "#78A584"]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              style={styles.cta}
            >
              <Text style={styles.ctaText}>{t("home.intro.cta")}</Text>
            </LinearGradient>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
  },
  card: {
    backgroundColor: "#FFF",
    borderRadius: 20,
    padding: 24,
    width: "100%",
    maxWidth: 420,
    maxHeight: "85%",
  },
  closeButton: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 1,
    width: 36,
    height: 36,
    borderRadius: 18,
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontFamily: "Inter_700Bold",
    fontSize: 22,
    color: "#1C453F",
    marginBottom: 16,
    marginRight: 32,
    lineHeight: 28,
  },
  paragraph: {
    fontFamily: "Inter_400Regular",
    fontSize: 14,
    color: "#333",
    lineHeight: 22,
    marginBottom: 12,
  },
  paragraphBold: {
    fontFamily: "Inter_700Bold",
    fontSize: 16,
    color: "#CD7728",
    marginTop: 8,
    marginBottom: 8,
  },
  ctaWrapper: {
    marginTop: 16,
    borderRadius: 12,
    overflow: "hidden",
  },
  cta: {
    paddingVertical: 16,
    alignItems: "center",
  },
  ctaText: {
    fontFamily: "Inter_700Bold",
    fontSize: 16,
    color: "#FFF",
  },
});
